export function ZoomIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="17"
      height="11"
      viewBox="0 0 17 11"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="13" height="11" rx="3" fill="currentColor" />
      <path d="M14 3L17 1V10L14 8V3Z" fill="currentColor" />
    </svg>
  );
}
